export enum ActionType {
  LOGIN_REQUEST = 'login_request',
  LOGIN_SUCCESS = 'login_success',
  LOGIN_ERROR = 'login_error',
  RESET_LOGIN_PAGE_PREVIOUS_STATE = 'reset_login_page_previous_state'
}
